import { Container, Navbar, Nav } from "react-bootstrap";
import "../Assets/Css/Components/NavMenu.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../Reducers/Store";
import React, { useCallback, useState, useEffect, useContext } from "react";

function NavMenu(props) {
  const [state, dispatch] = useContext(Context);
  let navigate = useNavigate();
  let location = useLocation();

  const handleLogout = () => {
    dispatch({ type: "SET_LOGGED", payload: null });
    dispatch({ type: "SET_HUB", payload: null });
    navigate("/", { replace: false });
  };

  const handleNavigate = (event, to) => {
    navigate(to, { replace: false });
    event.preventDefault();
  };

  return (
    <Navbar className="mb-2" style={{ display: "none" }}>
      <Container fluid style={{ ...props.style }}>
        <Navbar.Collapse className="justify-content-end">
          <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavMenu;
